import React, { Suspense } from "react";

import { Route, Routes } from "react-router-dom";
import * as LazyComponent from "../utils/LazyLoaded";

import { ROUTES } from "./AppRoutes";

const CustomRoutes = () => {
  return (
    <Suspense>
      <Routes>
        {/* <Route element={<PrivateRoutes />}> */}
        <Route
          element={<LazyComponent.AppLayout appBar={true} appFooter={true} />}
        >
          <Route
            path={ROUTES.HOME_SCREEN}
            element={<LazyComponent.HomePage />}
          />
        </Route>
        <Route path={ROUTES.BASE_URL} element={<LazyComponent.HomeScreen />} />
        <Route path={ROUTES.SITE_DOWN} element={<LazyComponent.SiteDown />} />
        <Route
          path={ROUTES.SELECT_CAT}
          element={<LazyComponent.SelectType />}
        />
        {/* </Route> */}
        <Route
          element={<LazyComponent.AppLayout appBar={true} appFooter={true} />}
        >
          <Route path={`${ROUTES.SEARCH}`} element={<LazyComponent.Search />} />
        </Route>
        <Route
          element={<LazyComponent.AppLayout appBar={true} appFooter={true} />}
        >
          <Route path={`${ROUTES.FILTER}`} element={<LazyComponent.Filter />} />
        </Route>
        {/* No Header Footer Layout */}
        <Route
          element={<LazyComponent.AppLayout appBar={false} appFooter={false} />}
        >
          <Route
            path={`${ROUTES.PRODUCT_DETAILED}/:id`}
            element={<LazyComponent.MenuDetailed />}
          />
        </Route>
        <Route
          element={<LazyComponent.AppLayout appBar={false} appFooter={false} />}
        >
          <Route
            path={`${ROUTES.PRODUCT_DETAILEDIT}/:id`}
            element={<LazyComponent.MenuDetailEdit />}
          />
        </Route>
        <Route path={ROUTES.APP_ORDERS} element={<LazyComponent.Orders />} />
        <Route
          path={ROUTES.APP_ASSISTANCE}
          element={<LazyComponent.Assistance />}
        />
        <Route path={ROUTES.PAYMENT} element={<LazyComponent.Payment />} />
        <Route path={ROUTES.APPLEPAY} element={<LazyComponent.ApplePay />} />
        <Route
          path={ROUTES.SAMSUNGPAY}
          element={<LazyComponent.SamsungPay />}
        />
        <Route
          path={ROUTES.CHARGE_TO_ROOM}
          element={<LazyComponent.ChargeToRoom />}
        />
        <Route path={ROUTES.FACE_RECOG} element={<LazyComponent.FaceRecog />} />
        {/* Profile App Routes */}
        <Route path={ROUTES.LOGIN} element={<LazyComponent.Login />} />
        <Route path={ROUTES.REGISTER} element={<LazyComponent.Register />} />
        <Route
          path={ROUTES.EMAIL_VERIFY}
          element={<LazyComponent.EmailVerify />}
        />
        <Route
          path={ROUTES.FORGOT_PASS}
          element={<LazyComponent.ForgotPassword />}
        />
        <Route
          path={ROUTES.RESET_PASS}
          element={<LazyComponent.ResetPassword />}
        />
        <Route
          path={ROUTES.PROFILE_VIEW}
          element={<LazyComponent.ProfileView />}
        />
        <Route
          path={ROUTES.MANAGE_USERS}
          element={<LazyComponent.ManageUsers />}
        />
        <Route
          path={ROUTES.ORDER_HISTORY}
          element={<LazyComponent.OrderHistory />}
        />
        <Route
          path={ROUTES.POST_PAYMENT_PROCESS}
          element={<LazyComponent.PostPaymentProcess />}
        />
      </Routes>
    </Suspense>
  );
};

export default CustomRoutes;
